/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Filter_MuscleInputs */

const en_us2_exercise_filter_muscle = /** @type {(inputs: Exercise_Filter_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle`)
};

const pt_br2_exercise_filter_muscle = /** @type {(inputs: Exercise_Filter_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculo`)
};

const es_419_exercise_filter_muscle = /** @type {(inputs: Exercise_Filter_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculo`)
};

const pt_pt2_exercise_filter_muscle = /** @type {(inputs: Exercise_Filter_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculo`)
};

const fr_fr2_exercise_filter_muscle = /** @type {(inputs: Exercise_Filter_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle`)
};

const de_de2_exercise_filter_muscle = /** @type {(inputs: Exercise_Filter_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskel`)
};

const it_it2_exercise_filter_muscle = /** @type {(inputs: Exercise_Filter_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscolo`)
};

/**
* | output |
* | --- |
* | "Muscle" |
*
* @param {Exercise_Filter_MuscleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_filter_muscle = /** @type {((inputs?: Exercise_Filter_MuscleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Filter_MuscleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_filter_muscle(inputs)
	if (locale === "es-419") return es_419_exercise_filter_muscle(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_filter_muscle(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_filter_muscle(inputs)
	if (locale === "de-DE") return de_de2_exercise_filter_muscle(inputs)
	if (locale === "it-IT") return it_it2_exercise_filter_muscle(inputs)
	return en_us2_exercise_filter_muscle(inputs)
});
export { exercise_filter_muscle as "exercise.filter_muscle" }